<template>
    <div class="media-organizer-container">
        <div class="selectors" :class="{ right: isRightAligned }">
            <button
                v-for="selector in selectors"
                :key="selector.value"
                :class="selector.selected ? 'selected' : ''"
                @click="select(selector)"
                class="selector"
            >
                {{ `${selector.text} (${counter(selector.value)})` }}
            </button>
        </div>
        <ImageView
            v-if="selected === 'images'"
            :images="images"
            :profile-pic-indx.sync="profileIndx"
            :hover-index.sync="hoverIndex"
            :editable="editable"
            @edit-photo="onEditPhoto"
            @delete-image="deleteImage"
        />
        <VideoView
            v-if="selected === 'videos'"
            :videos="loadedVideos"
            :hover-index.sync="hoverIndex"
            :editable="editable"
            @load-video="loadVideo"
            @delete-video="deleteVideo"
        />

        <AudioView
            v-if="selected === 'audios'"
            :audios="audios"
            :editable="editable"
            @new-songs="updateSongs"
        />
    </div>
</template>
<script>
    import ImageView from './ImageView'
    import VideoView from './VideoView'
    import AudioView from './AudioView'
    import { useMediaOrganizer } from '@/composables/ui/useMediaOrganizer'

    export default {
        name: 'MediaOrganizer',
        components: {
            ImageView,
            VideoView,
            AudioView
        },
        props: {
            userId: {
                type: Number,
                required: true
            },
            audios: {
                type: Array,
                required: false,
                default: () => []
            },
            images: {
                type: Array,
                required: false,
                default: () => []
            },
            profilePicIndx: {
                type: Number,
                required: false
            },
            videos: {
                type: Array,
                required: false,
                default: () => []
            },
            editable: {
                type: Boolean,
                required: false,
                default: true
            },
            isRightAligned: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        emits: ['update:audios', 'edit-photo'],
        setup(props) {
            const {
                hoverIndex,
                selectors,
                selected,
                select,
                deleteImage,
                loadedVideos,
                loadVideo,
                deleteVideo
            } = useMediaOrganizer(props)

            return {
                hoverIndex,
                selectors,
                selected,
                select,
                deleteImage,

                loadedVideos,
                loadVideo,
                deleteVideo
            }
        },
        data: (self) => ({
            profileIndx: self.profilePicIndx
        }),
        computed: {
            counter(self) {
                return (selector) => {
                    switch (selector) {
                        case 'images':
                            return self.images.length
                        case 'videos':
                            return self.loadedVideos.length
                        case 'audios':
                            return self.audios.length
                        default:
                            return 0
                    }
                }
            }
        },
        watch: {
            profileIndx: {
                handler: function (val) {
                    this.$emit('update:profile-pic-indx', val)
                },
                immediate: true
            }
        },
        methods: {
            updateSongs(songs) {
                this.$emit('update:audios', songs)
            },
            onEditPhoto(image) {
                this.$nextTick(() => {
                    this.$emit('edit-photo', image)
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/variables';

    .media-organizer-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;

        .selectors {
            margin-left: auto;
            margin-right: auto;
            max-width: 343px;
            width: 100%;
            padding: 4px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 12px;
            background: #333333;

            .selector {
                width: 100%;
                padding: 8px 12px;
                background: inherit;
                color: #8b8b8b;
                @include base-font-14;
                line-height: 115%;
                letter-spacing: 0.14px;
                border-radius: 8px;
            }
            .selected {
                color: black;
                background: #cdeb09;
            }

            @media screen and (min-width: $mobile) {
                &.right {
                    margin-right: 0;
                }
            }
        }
    }
</style>
